import { render } from "./EmbedList.vue?vue&type=template&id=3750847f"
import script from "./EmbedList.vue?vue&type=script&lang=js"
export * from "./EmbedList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__